export const COUNTRIES_ACTIONS = {
  REQUESTED: 'countries/requested',
  SUCCEEDED: 'countries/succeeded',
  FAILED: 'countries/failed',
};

export interface CountriesSucceeded {
  type: string;
  payload: { countries: any[] };
}

export const countriesSucceeded = (countries: any[]): CountriesSucceeded => ({
  type: COUNTRIES_ACTIONS.SUCCEEDED,
  payload: { countries },
});

export interface CountriesRequested {
  type: string;
}

export const countriesRequsted = (): CountriesRequested => ({
  type: COUNTRIES_ACTIONS.REQUESTED,
});

export interface CountriesFailed {
  type: string;
  error: string;
}

export const countriesFailed = (error: string) => ({
  error,
  type: COUNTRIES_ACTIONS.FAILED,
});

export type CountriesAction =
  | CountriesRequested
  | CountriesSucceeded
  | CountriesFailed;



// WEBPACK FOOTER //
// ./src/scenes/Countries/services/actions.ts